import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const LeadColumn = ({ title, color }) => {
  return (
    <div className="mb-4">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6>
          <span className="me-2" style={{color}}>●</span> {title}
        </h6>
        <div>⚙️ ✏️ 🗑</div>
      </div>

      <div className="row">
        {[1,2].map(i => (
          <div key={i} className="col-md-4 mb-3">
            <div className="card p-3 lead-card">
              <div className="fw-semibold">Linda White</div>
              <small className="text-muted">CEO</small>

              <p className="small mt-2">
                📧 mail@mail.com <br/>
                📞 +123456789
              </p>

              <div className="d-flex justify-content-between small">
                <span>👤</span>
                <span>📞 ✉️</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Leads = () => {
  return (
    <div className="container mt-4">
      <style>{`
        .lead-card { box-shadow:0 4px 12px rgba(0,0,0,0.08); border-radius:10px; }
      `}</style>

      <h4>Leads</h4>

      <LeadColumn title="Contacted" color="gold" />
      <LeadColumn title="Not Contacted" color="purple" />
      <LeadColumn title="Closed" color="green" />
      <LeadColumn title="Lost" color="red" />
    </div>
  );
};

export default Leads;